<template>
  <v-container class="page">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
      v-show="!overlay"
    >
      <v-card-title class="title font-weight-light">
        Work Order
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="5"
            offset="7"
          >
            <div class="d-flex justify-end gap-2">
              <v-btn
                class="mr-2"
                @click="showFormUpload = !showFormUpload"
              >
                UPLOAD WORK ORDER
              </v-btn>
              <v-btn
                color="#00ACDC"
                dark
                @click="createDialog = true"
              >
                CREATE WORK ORDER
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="showFormUpload">
          <v-col
            cols="5"
            offset="7"
          >
            <v-card
              class="pa-2"
              width="100%"
              style="border-radius:10px;"
            >
              <v-card-title>
                Upload Work Order
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                  >
                    <v-file-input
                      outlined
                      hide-details
                      label="Please Select File"
                      :rules="[(v) => !!v || 'File is required']"
                      v-model="file"
                      required
                      accept=".xlsx, .xls, .csv"
                      prepend-icon="mdi-file-upload"
                      @change="onFileChange"
                      @click:clear="file = null"
                    />
                  </v-col>
                </v-row>
                <v-progress-linear
                  v-if="loadingUpload"
                  indeterminate
                  color="#00ACDC"
                />
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                  >
                    <div class="d-flex">
                      <v-btn
                        :disabled="loadingUpload"
                        style="width: 49%; margin-right: 2%;"
                        @click="showFormUpload = false; file = null"
                      >
                        CANCEL
                      </v-btn>

                      <v-btn
                        @click="uploadFile"
                        type="submit"
                        :disabled="loadingUpload"
                        style="width: 49%;"
                        color="success"
                      >
                        UPLOAD
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="workOrders"
          class="font-weight-light pa-5"
          :loading="loadingType"
          loading-text="Loading..."
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="workOrderTotal"
          :options.sync="paginationOptions"
        >
          <template #[`item.no`]=" { item }">
            {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + workOrders.indexOf(item) + 1 }}
          </template>
          <template #[`item.action`]="{ item }">
            <v-icon
              small
              class="mr-2"
              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              color="red"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template #no-data>
            Work order not available, please create a new work order
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deleteDialog"
      persistent
      max-width="550"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
            this work order?
          </span>
        </v-card-title>
        <v-card-text>
          You will delete this work order permanently.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="deleteDialog = false"
            text
          >
            No
          </v-btn>
          <v-btn
            @click="deleteWorkOrder"
            text
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="createDialog"
      max-width="500px"
      persistent
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-application
              </v-icon>Create Work Order
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="my-0">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Code"
                    :rules="[(v) => !!v || 'Code is required']"
                    v-model="code"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Description"
                    :rules="[(v) => (!!v && !!v.trim()) || 'Description is required']"
                    v-model="description"
                    required
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                block
                @click="close"
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                block
                @click="save"
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editDialog"
      max-width="500px"
      persistent
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-application
              </v-icon>Update work order
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="px-0 py-0">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Code"
                    :rules="[(v) => !!v || 'Code is required']"
                    v-model="editedItem.code"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Description"
                    :rules="[(v) => (!!v && !!v.trim()) || 'Description is required']"
                    v-model="editedItem.description"
                    required
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                block
                @click="closeEdit"
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                block
                @click="saveEdit"
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */

const qs = require("qs");

export default {
  data: () => ({
    token: "",
    clientid: "",
    headers: [
      { text: "No", value: "no", sortable: false },
      { text: "Code", align: "left", value: "code" },
      { text: "Description", value: "description" },
      { text: "Actions", value: "action", sortable: false },
    ],
    deleteDialog: false,
    searchData: "",
    searchDataTimeout: null,
    createDialog: false,
    editDialog: false,
    deletedIndex: 0,
    deletedItem: {},
    editedIndex: 0,
    editedItem: {
      id: "",
      code: "",
      description: ""
    },
    valid: true,
    code: "",
    description: "",
    workOrders: [],
    loadingType: false,
    loadingUpdate: false,
    loader: null,
    overlay: false,
    workOrderTotal: 0,
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      sortBy: [],
      sortDesc: [],
      page: 1,
      itemsPerPage: 10
    },
    showFormUpload: false,
    file: null,
    loadingUpload: false
  }),
  mounted() {
    this.getWorkOrderTotal();
    this.getWorkOrder();
  },
  created() {
    this.token = this.$store.state.token;
    this.clientid = this.$store.state.clientid;
    this.overlay = true;
  },
  methods: {
    saveEdit() {
      if (this.$refs.form.validate()) {
        const item = this.workOrders.find((d) => d.id == this.editedItem.id);
        const datas = {
          clientid: this.clientid,
          id: item.id,
          code: this.editedItem.code,
          description: this.editedItem.description
        };

        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;

        this.$store.dispatch('API_CALL', {
            $method: 'update_work_order',
            $postData: {
              data: datas,
            },
          })
          .then(
						(response) => {
							if(response.data.code == 200) {
                this.$swal({
                  icon: 'success',
                  title: response.data.data.message,
                }).then((res) => {
                  if (res.isConfirmed) {
                    this.loadingUpdate = false;
                    this.loader = this.loadingUpdate;
                    this.editDialog = false;
                    this.getWorkOrderTotal();
                    this.getWorkOrder();
                  }
                })
              } else {
                this.$swal({
                  icon: 'error',
                  title: response.data.data.message,
                })
                .then((res) => {
                  if (res.isConfirmed) {
                    this.getWorkOrderTotal();
                    this.getWorkOrder();
                  }
                })
              }
            })
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        this.payloadApi = {
          clientid: this.clientid,
          code: this.code,
          description: this.description
        };
        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;
        this.$store.dispatch('API_CALL', {
            $method: 'create_work_order',
            $postData: {
              data: this.payloadApi,
            },
          })
          .then(
          (response) => {
            if(response.data.code == 200) {
              this.$swal({
                icon: 'success',
                title: response.data.data.message,
              }).then((res) => {
                if (res.isConfirmed) {
                  this.loadingUpdate = false;
                  this.loader = this.loadingUpdate;
                  this.close();
                  this.getWorkOrderTotal();
                  this.getWorkOrder();
                  this.$refs.form.reset();
                }
              })
            } else {
              this.$swal({
                icon: 'error',
                title: response.data.data.message,
              }).then((res) => {
                if (res.isConfirmed) {
                  this.loadingUpdate = false;
                  this.loader = this.loadingUpdate;
                  this.getWorkOrderTotal();
                  this.getWorkOrder();
                }
              })
            }
          })
      }
    },
    close() {
      this.createDialog = false;
      this.code = ""
      this.description = ""
      this.isVehicle = false
    },
    closeEdit() {
      this.editDialog = false;
    },
    getWorkOrderTotal() {
      return this.$store.dispatch('API_CALL', {
        $method: 'get_work_order_total',
        $postData: {
          clientid: this.$store.state.clientid,
          query: this.searchData
        },
      }).then((response) => {
        this.workOrderTotal = parseInt(response.data.data.total);
      })
    },
    getWorkOrder() {
      if (this.loadingType) return
      this.loadingType = true;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by  = sortBy.length ? sortBy[0] : 'code';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'asc';
      const offset   = (page - 1) * itemsPerPage;

      return this.$store.dispatch('API_CALL', {
          $method: 'get_work_order',
          $postData: {
            clientid: this.$store.state.clientid,
            limit: itemsPerPage,
            offset,
            sort_by,
            sort_dir,
            query: this.searchData
          },
        })
        .then((response) => {
          this.loadingType = false;
          this.workOrders = response.data.data;
        });
    },
    deleteItem(item) {
      this.deleteDialog = true;
      this.deletedIndex = this.workOrders.indexOf(item);
      this.deletedItem = Object.assign({}, item);
    },
    editItem(item) {
      this.editDialog = true;
      this.editedIndex = this.workOrders.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.description = item.description;
    },
    deleteWorkOrder() {
      const item = this.workOrders.find((d) => d.id == this.deletedItem.id);
      this.deleteDialog = false;

      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      console.log(item);
      return this.$store.dispatch('API_CALL', {
          $method: 'delete_work_order',
          $postData: {
            id: item.id,
          },
        })
        .then(
          (response) => {
            if(response.data.code == 200) {
              this.$swal({
                icon: 'success',
                title: response.data.data.message,
              })
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              Promise.all([
                this.getWorkOrderTotal(),
                this.getWorkOrder(),
              ]).then(() => {
                if (this.workOrderTotal > 0 && this.workOrders.length === 0) {
                  this.paginationOptions.page = 1
                  this.getWorkOrder();
                }
              })
            } else {
              this.$swal({
                icon: 'error',
                title: response.data.data.message,
              })
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
            }
          })
    },
    updatePaging(options) {
      this.getWorkOrderTotal();
      this.paginationOptions = options;
      this.getWorkOrder();
    },
    uploadFile() {
      if (this.file) {
        this.loadingUpload = true;
        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("clientid", this.clientid);

        this.$store.dispatch('API_CALL', {
            $method: 'upload_work_order',
            $postData: {
              uploadType: 'file',
              data: formData,
            },
          })
          .then(
            (response) => {
              if(response.data.code == 200) {
                this.$swal({
                  icon: 'success',
                  title: response.data.data.message,
                }).then((res) => {
                  if (res.isConfirmed) {
                    this.loadingUpload = false;
                    this.showFormUpload = false;
                    this.getWorkOrderTotal();
                    this.getWorkOrder();
                  }
                })
              } else {
                this.$swal({
                  icon: 'error',
                  title: response.data.data.message,
                })
                .then((res) => {
                  if (res.isConfirmed) {
                    this.loadingUpload = false;
                    this.loader = this.loadingUpload;
                    this.getWorkOrderTotal();
                    this.getWorkOrder();
                  }
                })
              }
            })
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.file = file;
      }
    },
  },
  computed: {},
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 500);

      this.loader = null;
    },
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 500)
    },
    searchData() {
      clearTimeout(this.searchDataTimeout)
      this.searchDataTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.getWorkOrderTotal();
        this.getWorkOrder();
      }, 1e3)
    }
  },
};
</script>
<style lang="css" scoped></style>
